import React from 'react';
//@ts-ignore
import { Bar, Chart } from 'react-chartjs-2';
import { IonText } from '@ionic/react';
import 'chartjs-plugin-annotation';
import { getformatNumber } from '../common/utils';
import { ChartOptions } from 'chart.js';
// import * from 'chartjs-plugin-annotation';

export interface BarData {
    barNumber: number,
    name: string,
    color: string
}

export interface BarSalesData {
    ytd: number,
    projected: number,
    goal: number,
    goalPercent: number
}

interface Props {
    barData: BarData;
    barSalesData: BarSalesData;
    isClickable: boolean;
    setSelectedBarData: (barData: BarData) => void;
    chartReference: React.RefObject<unknown>;
    hasNoData: boolean;
}

class BarElement extends React.Component<Props> {
    
    onClick = (e: any) => {
        if (!this.props.isClickable) return;
        this.props.setSelectedBarData(this.props.barData);
    }

    checkUpdate = (e: any) => {
        e.data.datasets[0].data[0] = 0;

        setTimeout(() => {
            e.data.datasets[0].data[0] = this.props.barSalesData.ytd;
            e.update({
                duration: 2000,
                easing: 'easeOutQuart'
            });
        }, 100);
    }

    componentDidMount() {
        Chart.pluginService.register({
            afterDraw: () => {
                //@ts-ignore
                if(this.refs.chart){
                    //@ts-ignore
                    let ctx = this.refs.chart.chartInstance.chart.ctx;
                    ctx.font = "14px Verdana";
                    ctx.fillStyle = "#ffffff";
                    ctx.textAlign = "center";
                    ctx.textBaseline = "bottom";
                    let prefix = "";
                    if(this.props.barData.name === "Sales"){
                        prefix = "$"
                    }
                    //@ts-ignore
                    this.refs.chart.chartInstance.chart.config.data.datasets.forEach(function (dataset) {
                            const dataArray = dataset.data;
                            // console.log('dataset.data', dataset.data,Object.keys(dataset._meta)[0]);
                            dataset._meta[Object.keys(dataset._meta)[0]].data.forEach(function (bar, index) {
                                ctx.fillText(prefix+getformatNumber(dataArray[0],0), bar._view.x, bar._view.y);
                            });
                    })
                }
            }
        });
    }
    
    returnTrashholdVal(){
        const hasNoData = this.props.hasNoData;
         if(hasNoData){
             return "";
        } else {
            return this.props.barData.name === "Sales" ? '$' + getformatNumber(this.props.barSalesData.goal, 0):  getformatNumber(this.props.barSalesData.goal, 0);
        }
    }

    render() {
        var barChartData = {
            labels: [this.props.barData.name],
            datasets: [
                {
                    data: [
                        this.props.barSalesData.ytd,
                    ],
                    backgroundColor: [
                        this.props.barData.color,
                    ],
                    /*barPercentage: .8,*/
                    categoryPercentage: .8,
                    /*barThickness: 6,*/
                    /* maxBarThickness: 8,*/
                    minBarLength: 2,
                }
            ],

        };

        var barChartOptions = {
            animation: {
                duration: 3000,
            },
            annotation: {
              annotations: [{
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-0',
                value: this.props.barSalesData.goal,
                borderColor: '#fff',
                borderWidth: 2,
                label: {
                  enabled: true,
                  backgroundColor: 'transparent',
                  position: "left",
                  fontColor: "#fff",
                  yAdjust: 12,
                  content: this.returnTrashholdVal()
                }
              }]
            },
            responsive: true,
            layout: {
                padding: {
                    top: 25,
                    left: 15,
                    right: 15,
                    bottom: 15
                }
            },          
            responsiveAnimationDuration: 0,
            maintainAspectRatio: false,
            onResize: this.checkUpdate,
            onClick: this.onClick,
            legend: {
                display: false
            },
            tooltips: {
                enabled: false
            },
            scales: {
                yAxes: [{
                    //stacked: true,
                    ticks: {
                        // z: 1,
                        beginAtZero: true,
                        //min: 0,
                        max: parseInt(this.props.barSalesData.goal.toString()) >  parseInt(this.props.barSalesData.ytd.toString()) ?  parseInt(this.props.barSalesData.goal.toString()) : (parseInt(this.props.barSalesData.ytd.toString()) + parseInt(this.props.barSalesData.ytd.toString())*.02),
                        labelOffset: 8,
                        padding: -5,
                        maxTicksLimit: 2,
                        //precision: 10,
                        //stepSize: 20,

                        //sampleSize: 0
                        autoSkip: false,
                        mirror: true,
                        callback: function (value: any, index: any, values: any) {
                            // return isStringANumber(value);
                            if(value === 0)
                                return 0;
                                // return (value < 1000000) ? value / 1000 + 'K' : value / 1000000 + 'M';
                            return '';
                        },
                        fontColor: 'rgba(255, 255, 255, 1)'
                    },
                    gridLines: {
                        offsetGridLines: true,
                        zeroLineWidth: 1.5,
                        display: false,
                        drawBorder: false,//does not change anything
                        drawTicks: false,
                        tickMarkLength: 10,
                        color: 'rgba(255, 255, 255, 0.5)',
                        zeroLineColor: 'rgba(255, 255, 255, 1)',
                    },
                    // fontColor: 'rgba(255, 255, 255, 1)'
                }],
                xAxes: [{
                    //stacked: true,
                    ticks: {
                        padding: 20,
                        backdropColor: 'rgba(255, 255, 255, 1)',
                        beginAtZero: true,
                        fontColor: 'rgba(255, 255, 255, 0)',
                        
                    },
                    // fontColor: 'rgba(255, 255, 255, 1)'
                    gridLines: {
                        zeroLineWidth: 1.5,
                        zeroLineColor: 'rgba(255, 255, 255, 1)',
                        display: true,
                        drawTicks: false,
                        tickMarkLength: 10,
                        color: 'rgba(255, 255, 255, 1)',
                        lineWidth: 0
                        
                    },

                }]

            }
        } as ChartOptions;


        return (
            
            <div className="bar-component">
                {this.props.hasNoData &&
                <IonText class="fix-to-chart">Progress will be displayed upon receipt of your first order</IonText>
                }
                {/* <IonText className="bar-points">{this.props.barSalesData.ytd}</IonText> */}
                <div className="bar-container" id="cont" >
                    <Bar
                        //@ts-ignore
                        // ref={'chart-'+this.props.barData.name}
                        ref={'chart'}
                        data={barChartData}
                        options={barChartOptions}
                    />
                </div>
                <IonText className="bar-name">{this.props.barData.name}</IonText>
            </div>
        );
    }
};

export default BarElement;